import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

interface MenuItem {
  id: number;
  title: string;
  link: string;
}

const menus: MenuItem[] = [
  {
    id: 1,
    title: "Inicio",
    link: "/",
  },
  {
    id: 2,
    title: "Nosotros",
    link: "/about",
  },
  {
    id: 3,
    title: "Servicios",
    link: "/service",
  },
  {
    id: 4,
    title: "Contacto",
    link: "/contact",
  },
];

const MobileMenu: React.FC = () => {
  const handleClick = () => {};

  return (
    <ul className="responsivemenu">
      {menus.map((menu) => (
        <li key={menu.id}>
          <Link to={menu.link} onClick={handleClick}>
            {menu.title}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default MobileMenu;
